const PageTitle = ({ svg, p1, p2, p3 }) => {
  return (
    <div className="container text-center bg-success bg-gradient rounded my-5">
      <div className="row py-5">
        <div className="col-md-6 mt-5 text-white">
          <h2 className="text-white">Contact Us</h2>
          <div
            className="contact_paras"
          >
            <p>{p1}</p>
            <p>{p2}</p>
            <p>{p3}</p>
          </div>
        </div>
        <div className="col-md-6">
          <img
            src={svg}
            alt=""
            className="img_svg"
            style={{ width: "50%" }}
            draggable="false"
          />
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
